import React, { useState, useEffect } from "react";
import Axios from "axios";
import "../Research/Project.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Project = () => {
  const { t, i18n } = useTranslation();
  const [projectList, setProjectList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // 현재 페이지
  const [totalPages, setTotalPages] = useState(1); // 전체 페이지 수
  const navigation = useNavigate();

  // 현재 언어 가져오기
  const currentLanguage = i18n.language;

  const moveDetail = (idx) => {
    navigation(`/project/detail/${idx}`);
    window.location.reload();
  };

  //프로젝트 페이징처리
  const handlePagination = (page) => {
    setCurrentPage(page);
  };
  //페이지 변경 시 DATA호출
  useEffect(() => {
    Axios.get(
      `http://micronpharm.com/api/get/project_paging?page=${currentPage}`
    )
      .then((res) => {
        setProjectList(res.data.paging);
        setTotalPages(res.data.totalPages);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [currentPage]);

  return (
    <div className="sub-wrap">
      <div className="inner_page_title">Project</div>
      <h2 style={{ textAlign: "center", paddingBottom: 20 }}>
        {t("project.project01")}
      </h2>
      <div className="content">
        <div className={`project-image ${currentLanguage}`}></div>
        <div className="inner_page_title_sub">Current Project</div>
        <div className="table_area">
          <div className="table_row table_header">
            <div className="row_box">
              <div className="row_text num">No.</div>
              <div className="row_text title">제목</div>
              <div className="row_text date">날짜</div>
              <div className="row_text clip_text">파일</div>
            </div>
          </div>
          {projectList.map((item, idx) => (
            <div
              className="table_row"
              key={(currentPage - 1) * 10 + idx}
              onClick={() => moveDetail(item.idx)}
            >
              <div className="row_box">
                <div className="row_text num">
                  {(currentPage - 1) * 10 + idx + 1}
                </div>
                <div className="row_text title">{item.title}</div>
                <div className="row_text date">{item.formatDate}</div>
                <div className="row_text clip">
                  {item.image !== null ? <div className="clip_icon"></div> : ""}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="pagination_box">
          <button onClick={() => handlePagination(1)}>{`<<`}</button>
          <button
            onClick={() => {
              if (currentPage > 1) {
                handlePagination(currentPage - 1);
              }
            }}
          >
            {`<`}
          </button>
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => handlePagination(i + 1)}
              className={currentPage === i + 1 ? "active" : ""}
            >
              {i + 1}
            </button>
          ))}
          <button
            onClick={() => {
              if (currentPage < totalPages) {
                handlePagination(currentPage + 1);
              }
            }}
          >
            {`>`}
          </button>
          <button onClick={() => handlePagination(totalPages)}>{`>>`}</button>
        </div>
      </div>
    </div>
  );
};

export default Project;
